import clsx from "clsx";
import React from "react";
import { Loader } from "../../common/components/Loader";
import { NoSearchResults } from "../../search/NoSearchResults";
import { Paging } from "../../search/result/paging/Paging";
import { SearchResults } from "../../search/result/SearchResults";
import useSearchState from "../../search/useSearchState";
import { Ad } from "../sidebar/ads/Ad";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { resultTableConfigType } from "../../common/types/search/results";

export function NewsSearchResultsContainer({
	resultTableConfig,
}: {
	resultTableConfig: resultTableConfigType;
}) {
	const { loading, error, paging, resultExists, resultIsInvalid, warnings } =
		useSearchState([""]);
	const { isMobile } = useAccessWindowSize();

	let content;
	let pagination;

	if (loading) {
		content = <Loader label="Loading results..." />;
	} else if (error || !resultExists || resultIsInvalid) {
		content = (
			<NoSearchResults error={error} resultIsInvalid={resultIsInvalid} />
		);
	} else {
		content = (
			<SearchResults
				resultTableConfig={resultTableConfig}
				paging={paging}
				warnings={warnings}
			/>
		);
		pagination = <Paging paging={paging} />;
	}

	return (
		<div className="search-results-container">
			{pagination}

			<div className="search-results" id="searchResults">
				<div className={clsx("results-container", { loading })}>
					{content}
				</div>
			</div>

			<footer className="search-footer grid">{pagination}</footer>

			{isMobile && <Ad code={`sidebar_5`} />}
		</div>
	);
}
